import DropDown from "src/Components/DropDown/DropDown";
import { SupportRoles } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { IUser } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { useSupportPermissions } from "src/Utils/Hooks/useGetAdminInfo/useSupportPermissions";
import { useChangeSupportUserRoleWrapper } from "src/Utils/Hooks/useGetAdminInfo/useChangeSupportUserRoleWrapper";

interface IUpdateUserRoleProps {
    user: IUser;
}

const UpdateUserRole: React.FC<IUpdateUserRoleProps> = ({ user }) => {
    const { isSupportAdmin, isCurrentUser } = useSupportPermissions();
    const { updateRole } = useChangeSupportUserRoleWrapper();

    const disabled = !isSupportAdmin || isCurrentUser(user.userId);

    return (
        <div style={{ display: 'flex' }}>
            <DropDown
                disabled={disabled}
                items={[SupportRoles.Member, SupportRoles.Admin]}
                selectedItem={user.role}
                onSelectionChange={(item) => updateRole(user.userId, item as SupportRoles)}
            />
        </div>
    );
};

export default UpdateUserRole;
